import { PropsWithChildren } from 'react'

import Footer from '@/components/layout/Footer'
import Header from '@/components/layout/Header'
import { LenisProvider } from '@/contexts/lenis'

import { WPPageData } from '@/types'

export type LayoutProps = PropsWithChildren<{ pageData: WPPageData }>

const Layout = ({ children }: LayoutProps) => {
  return (
    <LenisProvider>
      <Header />
      <main className="min-h-svh-vh">{children}</main>
      <Footer />
    </LenisProvider>
  )
}

export default Layout
